"use strict";

var __makeTemplateObject = this && this.__makeTemplateObject || function (cooked, raw) {
  if (Object.defineProperty) {
    Object.defineProperty(cooked, "raw", {
      value: raw
    });
  } else {
    cooked.raw = raw;
  }
  return cooked;
};
var __assign = this && this.__assign || function () {
  __assign = Object.assign || function (t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
      s = arguments[i];
      for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
    }
    return t;
  };
  return __assign.apply(this, arguments);
};
var __createBinding = this && this.__createBinding || (Object.create ? function (o, m, k, k2) {
  if (k2 === undefined) k2 = k;
  var desc = Object.getOwnPropertyDescriptor(m, k);
  if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
    desc = {
      enumerable: true,
      get: function () {
        return m[k];
      }
    };
  }
  Object.defineProperty(o, k2, desc);
} : function (o, m, k, k2) {
  if (k2 === undefined) k2 = k;
  o[k2] = m[k];
});
var __setModuleDefault = this && this.__setModuleDefault || (Object.create ? function (o, v) {
  Object.defineProperty(o, "default", {
    enumerable: true,
    value: v
  });
} : function (o, v) {
  o["default"] = v;
});
var __importStar = this && this.__importStar || function (mod) {
  if (mod && mod.__esModule) return mod;
  var result = {};
  if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
  __setModuleDefault(result, mod);
  return result;
};
var __read = this && this.__read || function (o, n) {
  var m = typeof Symbol === "function" && o[Symbol.iterator];
  if (!m) return o;
  var i = m.call(o),
    r,
    ar = [],
    e;
  try {
    while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
  } catch (error) {
    e = {
      error: error
    };
  } finally {
    try {
      if (r && !r.done && (m = i["return"])) m.call(i);
    } finally {
      if (e) throw e.error;
    }
  }
  return ar;
};
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.EntityFormLayout = exports.EntityFormLayoutDefaultProps = exports.ENTITY_FORM_QUERY = void 0;
var React = __importStar(require("react")); // tslint:disable-line
var styled_components_1 = __importStar(require("styled-components"));
var theme_1 = require("@shapeable/theme");
var client_1 = require("@apollo/client");
var client_2 = require("@apollo/client");
var lodash_1 = require("lodash");
var use_lang_1 = require("../../hooks/use-lang");
var current_user_can_1 = require("../../utils/current-user-can");
var use_entities_1 = require("../../hooks/use-entities");
var use_icons_1 = require("../../hooks/use-icons");
var use_theme_1 = require("../../hooks/use-theme");
var use_entity_state_1 = require("../../hooks/use-entity-state");
var use_form_page_actions_1 = require("../../hooks/use-form-page-actions");
var use_entity_definition_named_1 = require("../../hooks/use-entity-definition-named");
var use_app_options_1 = require("../../hooks/use-app-options");
var use_statuses_1 = require("../../hooks/use-statuses");
var form_1 = require("../forms/form");
var entity_created_updated_1 = require("./entity-created-updated");
var entity_state_context_1 = require("../context/entity-state-context");
var entity_value_1 = require("./entity-value");
// This query is just "something" which will still work and allow the hook to always be called
exports.ENTITY_FORM_QUERY = (0, client_2.gql)(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  query EntityFormQuery {\n    __type(name: \"Entity\") {\n      name\n    }\n  }\n"], ["\n  query EntityFormQuery {\n    __type(name: \"Entity\") {\n      name\n    }\n  }\n"])));
exports.EntityFormLayoutDefaultProps = {
  fieldState: {},
  loading: false,
  paramState: '',
  isModal: false,
  fillModal: false,
  metadata: {},
  showModal: function () {},
  hideModal: function () {}
};
var useMemo = React.useMemo;
// -------- Styles -------->
var FormStyles = (0, theme_1.breakpoints)({
  base: (0, styled_components_1.css)(templateObject_2 || (templateObject_2 = __makeTemplateObject(["\n    width: 100%;\n    height: 100%;\n  "], ["\n    width: 100%;\n    height: 100%;\n  "])))
});
var InputSelectStyles = (0, theme_1.breakpoints)({
  base: (0, styled_components_1.css)(templateObject_3 || (templateObject_3 = __makeTemplateObject(["\n  "], ["\n  "])))
});
var InputTextStyles = (0, theme_1.breakpoints)({
  base: (0, styled_components_1.css)(templateObject_4 || (templateObject_4 = __makeTemplateObject(["\n  "], ["\n  "])))
});
var EntityCreatedUpdatedStyles = (0, theme_1.breakpoints)({
  base: (0, styled_components_1.css)(templateObject_5 || (templateObject_5 = __makeTemplateObject(["\n    \n  "], ["\n    \n  "])))
});
var SourceEntityHeadStyles = (0, theme_1.breakpoints)({
  base: (0, styled_components_1.css)(templateObject_6 || (templateObject_6 = __makeTemplateObject(["\n    padding-bottom: ", ";\n    margin-bottom: ", ";\n    ", ";\n  "], ["\n    padding-bottom: ", ";\n    margin-bottom: ", ";\n    ", ";\n  "])), theme_1.theme.UNIT(4), theme_1.theme.UNIT(4), theme_1.theme.H_DOT_BG_END())
});
// -------- Components -------->
var My = {
  Form: (0, styled_components_1.default)(form_1.Form)(templateObject_7 || (templateObject_7 = __makeTemplateObject(["", ""], ["", ""])), FormStyles),
  EntityCreatedUpdated: (0, styled_components_1.default)(entity_created_updated_1.EntityCreatedUpdated)(templateObject_8 || (templateObject_8 = __makeTemplateObject(["", ""], ["", ""])), EntityCreatedUpdatedStyles),
  SourceEntityHead: styled_components_1.default.div(templateObject_9 || (templateObject_9 = __makeTemplateObject(["", ""], ["", ""])), SourceEntityHeadStyles)
};
// -------- Types -------->
var EntityFormLayout = function (props) {
  var className = props.className,
    onSubmit = props.onSubmit,
    onChange = props.onChange,
    entityData = props.entityData,
    fieldState = props.fieldState,
    paramState = props.paramState,
    onCancel = props.onCancel,
    isCreate = props.isCreate,
    entityTypeName = props.entityTypeName,
    showModal = props.showModal,
    hideModal = props.hideModal,
    patchEntityData = props.patchEntityData,
    metadata = props.metadata,
    fillModal = props.fillModal,
    subLabel = props.subLabel,
    label = props.label,
    onNameBlur = props.onNameBlur,
    hasActiveModal = props.hasActiveModal;
  var isModal = props.isModal;
  var definition = (0, use_entity_definition_named_1.useEntityDefinitionNamed)(entityTypeName);
  var defaultData = {};
  var icons = (0, use_icons_1.useIcons)();
  var t = (0, use_lang_1.useLang)();
  var entities = (0, use_entities_1.useEntities)();
  var theme = (0, use_theme_1.useTheme)();
  var _a = (0, use_statuses_1.useStatuses)(),
    PUBLISHED = _a.PUBLISHED,
    DRAFT = _a.DRAFT;
  var options = (0, use_app_options_1.useAppOptions)();
  var client = (0, client_1.useApolloClient)();
  var changePage = (0, use_form_page_actions_1.useFormPageActions)(entityTypeName).changePage;
  var _b = __read((0, use_entity_state_1.useEntityState)(entityTypeName, 'form'), 1),
    formState = _b[0];
  var form = definition.form;
  var modal = form.modal;
  var maxWidth = modal.maxWidth,
    fill = modal.fill;
  var onDelete = function () {
    // push this up 
    if (props.onDelete) {
      props.onDelete();
    }
  };
  // this query is to load all the data the form need to render controls. This is not record data for the entity itself.
  var _c = (0, client_1.useQuery)(form.query || exports.ENTITY_FORM_QUERY),
    _d = _c.data,
    data = _d === void 0 ? defaultData : _d,
    error = _c.error,
    loading = _c.loading;
  // console.log("ENTITY DATA IS", entityData);
  // console.log("ENTITY DATA LOADING IS", props.loading);
  var fieldsContext = {
    isCreate: isCreate,
    data: data,
    loading: loading,
    metadata: metadata,
    onNameBlur: onNameBlur,
    showModal: showModal,
    hideModal: hideModal,
    isModal: isModal,
    entityTypeName: entityTypeName,
    patchEntityData: patchEntityData,
    options: options,
    entityData: entityData || {},
    definition: definition,
    entities: entities,
    t: t,
    theme: theme,
    fieldState: fieldState,
    currentUserCan: current_user_can_1.currentUserCan,
    icons: icons,
    client: client,
    onChange: onChange
  };
  var fields = form.createFields(fieldsContext);
  var fieldSets = form.fieldSets;
  var transformedFieldState = form.transformFieldState ? form.transformFieldState(fieldState) : fieldState;
  // // infer which fields are prefilled from the URL (we'll need to load these in to populate the metadata)
  // const prefilledFields: PrefilledFieldInfo[] = useMemo(() => {
  //   if (isCreate) {
  //     const fieldDefinitions = form.fields || {};
  //     const parts = paramState ? paramState.split('/') : [];
  //     return parts.reduce((acc: any, part: string) => {
  //       const nameValue = part.split(':');
  //       if (nameValue.length) {
  //         const [name, value] = nameValue;
  //         if (name === 'modal') {
  //           acc.push({ name: 'modal', value: true });
  //         } else if (name !== 'from') {
  //           const field = fieldDefinitions[name];
  //           // only set if there is a field in this model with this name
  //           if (field) {
  //             acc.push({ name, value, type: field.type, entityTypeName: field.entityTypeName });
  //           }
  //         }
  //       }
  //       return acc;
  //     }, []);
  //   }
  //   return [];
  // }, [fields, definition, paramState, isCreate]);
  // const prefilledFieldsQuery = useMemo(() => {
  //   const prefilledFieldsNeedingData = (prefilledFields || []).filter(info => info.entityTypeName && !!entities[info.entityTypeName]);
  //   // console.log("PREFILLED FIELDS NEEDING DATA ARE", prefilledFieldsNeedingData);
  //   return prefilledFieldsNeedingData.length ?
  //     gql`
  //       query PrefilledFieldsQuery {
  //         ${prefilledFieldsNeedingData.map((info) => {
  //           const fieldDefn = info.entityTypeName && entities[info.entityTypeName];
  //           if (fieldDefn) { 
  //             const queryString = `${info.name}: list${fieldDefn.pluralTypeName}(filter: { id: { in: [${toArray(info.value).map(val => `"${val}"`).join(',')}] } }) {
  //               meta {
  //                 total
  //                 count
  //               }
  //               results {
  //                 id
  //                 slug
  //                 name
  //                 isDraft
  //                 isPublished
  //                 _optionLabel
  //                 ${fieldDefn.select.queryFields || ''}
  //               }
  //             }`;
  //             // console.log(queryString);
  //             return queryString;
  //           }
  //           return '';
  //         })}
  //       }
  //     ` : ENTITY_FORM_QUERY
  // }, [prefilledFields]);
  // const { data: prefilledFieldData, loading: prefilledLoading } = useQuery(prefilledFieldsQuery);
  // // if there is any prefilled data, augment the metadata
  // const fieldsWithMetadata = (isCreate && prefilledFieldData) ? produce(fields, draft => {
  //   forEach(prefilledFieldData, (listResults, fieldName) => {
  //     const fieldIndex = findIndex(fields, field => field.name === fieldName);
  //     if (fieldIndex !== -1) {
  //       draft[fieldIndex].disabled = true; // it must be readonly too
  //       draft[fieldIndex].metadata = draft[fieldIndex].metadata || {};
  //       draft[fieldIndex].metadata.prefill = listResults.results || [];
  //     }
  //   })
  // }) : fields;
  // // pre-fill field values
  // const finalFieldState = (isCreate && prefilledFields.length) ? 
  //   produce(transformedFieldState, draft => {
  //     forEach(prefilledFields, (info) => {
  //       draft[info.name] = { value: info.value }
  //     })
  //   }) : transformedFieldState;
  // console.log(finalFieldState);
  // console.log(fieldsWithMetadata);
  var fieldsWithMetadata = fields;
  var finalFieldState = transformedFieldState;
  var prefilledLoading = false;
  var name = form.name || "".concat((0, lodash_1.kebabCase)(definition.typeName), "-form");
  // console.log("LAYOUT FORM STATE", formState, name);
  // console.log(formState);
  // manage/solutions/create/challenge:rec6787987,
  var statusValue = definition.usePublishStatus && (transformedFieldState && transformedFieldState.publishStatus && transformedFieldState.publishStatus.value || (isCreate ? DRAFT : PUBLISHED));
  var isDraft = statusValue && statusValue === DRAFT;
  var badge = isDraft && 'Draft';
  // Filter out any fields which are links to an entity type which is already present in the stack of modal forms
  // this prevents on-the-fly creation of something that is already being edited / updated, as this scenario causes an infinite loop freeze. 
  var _e = __read(React.useContext(entity_state_context_1.EntityStateContext), 1),
    entityState = _e[0];
  var entitiesWithModals = (0, lodash_1.pickBy)(entityState, function (entityStateItem) {
    return !!(entityStateItem.form && entityStateItem.form.activeModal);
  });
  var safeFields = (0, lodash_1.map)(fieldsWithMetadata, function (field) {
    // ensure that canCreate is false. If we allow this, the form gets stuck in an infinite loop as the form is already in the rendering stack.
    if (entitiesWithModals[field.entityTypeName]) {
      return __assign(__assign({}, field), {
        disallowCreate: true
      });
    }
    return field;
  });
  var nameIsHidden = !!(0, lodash_1.get)(fields.find(function (field) {
    return field.name === 'name';
  }), 'hidden');
  var labelEntity = {
    __typename: entityTypeName,
    name: nameIsHidden ? '' : (0, lodash_1.get)(entityData, 'name', "")
  };
  var labelElement = React.createElement(entity_value_1.EntityValue, {
    imageSize: 32,
    label: isCreate ? definition.create.label : definition.update.label,
    variant: "small",
    name: nameIsHidden ? '' : (0, lodash_1.get)(entityData, 'name', isCreate ? '(enter name)' : 'Please wait...'),
    entity: labelEntity
  });
  var head = props.sourceEntity && React.createElement(My.SourceEntityHead, null, React.createElement(entity_value_1.EntityValue, {
    entity: props.sourceEntity
  }));
  return React.createElement(My.Form, {
    startControls: entityData && React.createElement(My.EntityCreatedUpdated, {
      entity: entityData
    }),
    isModal: isModal,
    head: head,
    hasActiveModal: hasActiveModal,
    showDeleteButton: !isModal && !isCreate && entityData && entityData.isDeletable,
    onDelete: onDelete,
    fillModal: fill,
    labelElement: !isCreate && isModal && labelElement,
    icon: definition.icon,
    bufferAtEnd: form.bufferAtEnd,
    loading: props.loading || loading || prefilledLoading,
    paginate: form.paginate,
    page: formState.page,
    submitError: formState.error,
    entityTypeName: entityTypeName,
    isCreate: isCreate,
    label: label,
    subLabel: subLabel,
    statusValue: statusValue,
    badge: badge,
    name: name,
    showStripes: isDraft,
    onSubmit: onSubmit,
    onChange: onChange,
    onNameBlur: onNameBlur,
    onChangePage: changePage,
    onCancel: onCancel,
    className: className,
    fieldState: finalFieldState,
    fieldSets: fieldSets,
    fields: safeFields
  });
};
exports.EntityFormLayout = EntityFormLayout;
exports.EntityFormLayout.defaultProps = exports.EntityFormLayoutDefaultProps;
var templateObject_1, templateObject_2, templateObject_3, templateObject_4, templateObject_5, templateObject_6, templateObject_7, templateObject_8, templateObject_9;